import React, { useMemo } from "react";

import { useAppSelector } from "../../../app/hooks";

import { CreateChargeLoanLinkageFields} from "../../../api/charges";

import SelectableEntityCard from "./SelectableEntityCard";
import { selectLoansAndBorrowers } from "../../analysis/logic/verifications/verificationSlice";
import { FolderOpen } from "lucide-react";
import { getAccountProductInfo } from "../../creditAccounts/logic/slice";

interface LoanSelectionStepProps {  
  excludeLoanReferenceIds?: string[];
  
  selectedLoanIds: CreateChargeLoanLinkageFields[];

  onSelectionChange: (
    selectedLoanIds: CreateChargeLoanLinkageFields[],
  ) => void;
}

const LoanSelectionStep: React.FC<
  LoanSelectionStepProps
> = ({
  excludeLoanReferenceIds = [],
  selectedLoanIds,
  onSelectionChange,
}) => {
  const loans = useAppSelector(getAccountProductInfo);

  const filteredLoans = useMemo(
    () =>
      loans.filter(
        loan =>
          !excludeLoanReferenceIds.includes(
            loan.loan_reference_id,
          ),
      ),
    [loans, excludeLoanReferenceIds],
  );

  const handleLoanToggle = (
    loanReferenceId: string,
  ) => {
    const isSelected = selectedLoanIds.some(loan =>loan.loan_reference_id ===loanReferenceId);

    const updatedSelection = isSelected
      ? selectedLoanIds.filter(
          loan =>
            loan.loan_reference_id !==
            loanReferenceId,
        )
      : [
          ...selectedLoanIds,
          {
            loan_reference_id: loanReferenceId,
          },
        ];

    onSelectionChange(updatedSelection);
  };

  const hasLoans = filteredLoans.length > 0;

  return (hasLoans ? (
    <div className="flex flex-col gap-3">
      {filteredLoans.map(loan => {
        const borrowerName = loan.account_name?.trim() || "Name unavailable";

        return (
          <SelectableEntityCard
            key={loan.loan_reference_id}
            title={borrowerName}
            subtitle={`LR: ${loan.ext_account_number}`}
            selected={selectedLoanIds.some(
              selectedLoan =>
                selectedLoan.loan_reference_id ===
                loan.loan_reference_id,
            )}
            onClick={() =>
              handleLoanToggle(
                loan.loan_reference_id,
              )
            }
          />
        );
      })}
    </div>): (
      <div className="flex min-h-[280px] flex-col items-center justify-center gap-3">
        <FolderOpen
          size={40}
          className="text-[#A3A3A3]"
        />

        <div className="text-sm font-medium text-[#0A0A0A]">
          No loans available
        </div>

        <div className="text-xs text-[#737373]">
          There are no loans available to select.
        </div>
      </div>
      )
); 
};

export default LoanSelectionStep;